/**
 * Feature flags for controlling application features
 * These can be toggled without code changes in production
 */

export const FEATURE_FLAGS = {
  // Evidence file uploads - disabled for security enhancements
  EVIDENCE_FILES_ENABLED: false,
  
  // Virus scanning for uploads
  VIRUS_SCANNING_ENABLED: true,
  
  // File archiving (keep uploaded files after processing)
  ARCHIVE_UPLOADS_ENABLED: true,
  
  // Security audit logging
  AUDIT_LOGGING_ENABLED: true,
} as const;

export type FeatureFlag = keyof typeof FEATURE_FLAGS;

/**
 * Check if a feature is enabled
 */
export function isFeatureEnabled(flag: FeatureFlag): boolean {
  return FEATURE_FLAGS[flag] ?? false;
}

/**
 * Get feature flag from environment variable (for runtime configuration)
 */
export function getFeatureFlag(flag: FeatureFlag): boolean {
  // Allow override from environment variables
  const envKey = `REACT_APP_FEATURE_${flag}`;
  const envValue = process.env[envKey];
  
  if (envValue !== undefined) {
    return envValue === 'true';
  }
  
  return FEATURE_FLAGS[flag];
}


